import React from 'react';
import ReactDOM from 'react-dom';
import ReactTabbar from './react-tabbar.jsx';

const sections = [
  {
    url: 'mocks/section-1.json',
    params: {
      norce: 'hello'
    }
  },
  {
    url: 'mocks/section-2.json',
    params: {
      norce: 'world'
    }
  },
  {
    url: 'mocks/section-3.json',
    params: {
      norce: 'abcde'
    }
  }
];

ReactDOM.render(<ReactTabbar sections={sections} onSwitch={(index) => console.log(index)} />, document.getElementById('react-tabbar'));



/** WEBPACK FOOTER **
 ** ./src/javascript/react-tabbar-example.jsx
 **/